<template>
  <a-layout
    class="logisticsContainer"
    id="components-layout-demo-custom-trigger"
  >
    <a-layout-sider :trigger="null" collapsible v-model="collapsed">
      <div class="logo">
        <img @click="goHome" :src="collapsed ? logoClose : logoOpen" />
      </div>
      <Menu />
    </a-layout-sider>
    <a-layout>
      <a-layout-header class="headerStyle">
        <a-icon
          class="trigger"
          :type="collapsed ? 'menu-unfold' : 'menu-fold'"
          @click="collapsed = !collapsed"
        ></a-icon>
        <Header />
      </a-layout-header>
      <a-layout-content
        :style="{ margin: '2%', background: '#fff', minHeight: '80vh' }"
      >
        <div>
          <router-view></router-view>
        </div>
      </a-layout-content>
      <a-layout-footer style="text-align:center">
        <Footer />
      </a-layout-footer>
    </a-layout>
  </a-layout>
</template>
<script>
import Header from "../../Layouts/Header"; //
import Menu from "@/components/manpower/menu"; //
import Footer from "../../Layouts/Footer";
export default {
  data() {
    return {
      collapsed: false,
      logoOpen: require("../../assets/logo.png"),
      logoClose: require("../../assets/bird.png")
    };
  },
  components: {
    Header,
    Menu,
    Footer
  },
  methods: {
    goHome() {
      this.$router.push({ name: "home" });
    }
  }
};
</script>
<style lang="less">
.logisticsContainer {
  .ant-layout-header {
    height: 36px;
    line-height: 36px;
  }
  .trigger {
    padding: 0 28px;
    line-height: 36px;
    font-size: 20px;
  }
  .trigger:hover {
    background: #eee;
  }
  .logo {
    height: 40px;
    // background: #ffffff33;
    margin: 10px;
    img {
      height: 40px;
      margin-left: 10%;
    }
  }
  .ant-layout-header {
    display: flex;
    background: #fff;
    flex-direction: row;
    justify-content: space-between;
    padding: 0;
    padding-right: 3%;
  }
  .logo img {
    cursor: pointer;
  }
}
</style>
